<template>
    <div class="viewpoints-wrap">
        <Title v-if="page">
            <h2 v-html="page.title.rendered">Privacy Policy</h2>
        </Title>


        <div class="page-inner">

            <div class="privacy-policy-list" v-if="page && page.sections.length !== 0">
                <div class="item" v-for="(item, index) in page.sections" :key="index">
                    <header class="title" @click="item.is_show = !item.is_show">
                        <h3 v-html="item.title"></h3>
                        <span v-if="item.is_show">↑</span>
                        <span v-else>↓</span>
                    </header>

                    <slide-up-down :active="item.is_show" :duration="300">
                        <div class="box">
                            <Content v-html="item.content">
                            </Content>
                        </div>
                    </slide-up-down>
        


                </div>
            </div>

            <Loading v-if="$store.state.is_loading" class="static" />
        </div>
    </div>
</template>
<script>

import Title from '@/components/ui/Title.vue';
import Content from '@/components/ui/Content.vue';
import Link from '@/components/ui/Link.vue';
import Loading from '@/components/Loading.vue';

export default {
    name: 'team',

    data () {
        return {
            page: false,
        }
    },

    components: {
        Title,
        Content,
        Link,
        Loading,
    },

    watch: {
        '$route.params': {
            handler(params) {
                this.fetchData(params);
            },

            immediate: true,
        }
    },

    methods: {
        fetchData(params) {

            this.page = false;
            // this.current_page_id = false;

            this.$ajax.get('pages?slug=privacy-policy').then(res => {
                res.data[0].sections.forEach(item => {
                    item.is_show = false;
                });
                this.page = res.data[0];
                this.$store.state.is_loading = false;

                // this.sections = res.data[0].sections;

                document.title = window.globals.site_title + ' — ' + this.$decode(res.data[0].title.rendered);

            });


        },

    },




}
</script>

<style lang="scss">

    .privacy-policy-list {
        margin: var(--padding) var(--margin);

        .item {
            margin: var(--padding-50) var(--padding);
            // padding: var(--padding-50) 0;
            border-bottom: var(--border) solid;
        }

        .title {
            // font-size: var(--large-size);
            line-height: 1;
            cursor: pointer;
            padding: 0 0 var(--padding-50);
            display: flex;
            align-items: center;

            h3 {
                flex: 1;
                font-size: var(--large-size);
            }

            span {
                font-size: var(--large-size);
                padding: 0 .5rem;
            }
        }

        .ui-enter {
            margin: 0;
            overflow: hidden;
            
        }

        .ui-enter p, .ui-enter h1, .ui-enter h2, .ui-enter h3, .ui-enter h4, .ui-enter ul, .ui-enter ol {
            margin: 0 0 var(--padding-50) 0;
        }
    }

    @media only screen and (max-width: 767px) {
        .privacy-policy-list {
            margin: var(--padding) 0;

            .title h3 {
                line-height: 1.2;
            }
            .item {
                margin: var(--padding-50) 0;
            }
        }
    }

</style>